import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
const RaisingDay2026 = () => {
  useEffect(() => {
    document.title = "Raising Day -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Raising Day 2026</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Raising Day 2026</h1>
            </div>
          </div>
          <div className="row">

<section class="mascot-section">
        <div class="mascot-container">

            <div class="mascot-image-box">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/RaisingDay2026.jpeg" alt="Sky Mascot - TAFS"/>
            </div>

            <div class="content-box">
                <span class="tagline">Raising Day 2026</span>


                <div class="subtitle">
                    Meet Sky. Built for the skies. Born for The Air Force School.
                </div>

                <div class="info-card">
                    <h2>Why a Mascot?</h2>
                    <p>
                        As we gear up to celebrate our Raising Day, we wanted a symbol that truly represents who we are — one built for our own community, by our own community.
                    </p>
                </div>

                <div class="info-card">
                    <h2>Why an Eagle?</h2>
                    <p>
                        Sky, the eagle, stands for everything TAFS stands for: courage, vigilance, and the freedom to soar. Eagles fly higher and see farther than any other bird, just as we push our students to rise above limits and set their sights high. Sky is bold, sharp-eyed, and fearless — a true reflection of the Air Force spirit that lives in every one of us.
                    </p>
                </div>

    
            </div>

        </div>
    </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaisingDay2026;
